import { Validator } from '@vista-digital/validator';
import { defaultSeatPickerSeatAppearanceConfig, seatPickerSeatAppearanceConfigValidator } from './seat-appearance';
import { seatPickerSeatAppearanceStatesConfigValidator } from './seat-appearance-states';
export const defaultSeatPickerSeatAppearancesConfig = {
    default: defaultSeatPickerSeatAppearanceConfig,
    normal: {
        default: {
            iconName: 'normal-seat'
        },
        selected: {
            iconName: 'normal-seat-selected',
            showLabels: false
        }
    },
    wheelchair: {
        default: {
            iconName: 'wheelchair-seat',
            showLabels: false
        }
    },
    companion: {
        default: {
            iconName: 'companion-seat',
            showLabels: false
        }
    },
    sofaLeft: {
        default: {
            iconName: 'sofa-left-seat',
            labelOffsetX: 3,
            labelOffsetY: -3
        },
        selected: {
            iconName: 'sofa-left-seat-selected',
            showLabels: false
        }
    },
    sofaMiddle: {
        default: {
            iconName: 'sofa-middle-seat',
            labelOffsetX: 0,
            labelOffsetY: -3
        },
        selected: {
            iconName: 'sofa-middle-seat-selected',
            showLabels: false
        }
    },
    sofaRight: {
        default: {
            iconName: 'sofa-right-seat',
            labelOffsetX: -3,
            labelOffsetY: -3
        },
        selected: {
            iconName: 'sofa-right-seat-selected',
            showLabels: false
        }
    },
    friend: {
        default: {
            iconName: 'friend-seat',
            showLabels: false
        }
    }
};
export const seatPickerSeatAppearancesConfigValidator = Validator.object({
    default: seatPickerSeatAppearanceConfigValidator,
    normal: Validator.optional(seatPickerSeatAppearanceStatesConfigValidator),
    wheelchair: Validator.optional(seatPickerSeatAppearanceStatesConfigValidator),
    companion: Validator.optional(seatPickerSeatAppearanceStatesConfigValidator),
    sofaLeft: Validator.optional(seatPickerSeatAppearanceStatesConfigValidator),
    sofaMiddle: Validator.optional(seatPickerSeatAppearanceStatesConfigValidator),
    sofaRight: Validator.optional(seatPickerSeatAppearanceStatesConfigValidator),
    friend: Validator.optional(seatPickerSeatAppearanceStatesConfigValidator)
});
